<template>
  <div class="qrcode-page">
    <el-card shadow="hover" class="qrcode-card">
      <div class="header">
        <h2>📤 上传用户入群二维码</h2>
        <p class="desc">支持上传本地图片或填写网络地址，注册后将展示该二维码。</p>
      </div>

      <el-form :model="form" label-width="100px">
        <!-- 方式一：本地上传 -->
        <el-form-item label="上传图片">
          <el-upload
            class="upload-box"
            drag
            action
            :auto-upload="false"
            :show-file-list="true"
            :on-change="handleFileChange"
          >
            <i class="el-icon-upload"></i>
            <div>拖拽或点击上传二维码图片</div>
          </el-upload>
        </el-form-item>

        <!-- 方式二：图片链接 -->
        <el-form-item label="图片链接">
          <el-input
            v-model="form.image_url"
            placeholder="https://example.com/qrcode.png"
            clearable
          />
        </el-form-item>

        <!-- 操作按钮 -->
        <el-form-item>
          <el-button type="primary" @click="submitUpload">上传二维码</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>

      <div v-if="currentQrcode" class="preview">
        <h3>📷 当前二维码</h3>
        <img :src="qrcodeUrl" class="preview-img" />
      </div>
    </el-card>
  </div>
</template>
  
  <script>

import axios from 'axios';
export default {
  name: "QrcodeUpload",
  data() {
    return {
      form: {
        image_url: "",
        image: null
      },
      currentQrcode: null
    };
  },
  computed: {
    qrcodeUrl() {
      if (!this.currentQrcode) return "";
      return this.currentQrcode.image_type === "upload"
        ? `/api/uploads/qrcode/${this.currentQrcode.image_path}`
        : this.currentQrcode.image_url;
    }
  },
  methods: {
    handleFileChange(file) {
      this.form.image = file.raw;
    },
    async fetchCurrentQrcode() {
      try {
        const res = await axios.get("/api/admin/system/qrcode");
        this.currentQrcode = res.data;
      } catch (err) {
        console.warn("获取二维码失败", err);
      }
    },
    async submitUpload() {
      const formData = new FormData();

      if (this.form.image) {
        formData.append("image", this.form.image);
      }
      if (this.form.image_url) {
        formData.append("image_url", this.form.image_url);
      }

      if (!this.form.image && !this.form.image_url) {
        return this.$message.warning("请上传图片或填写链接");
      }

      try {
        await axios.post("/api/admin/system/qrcode", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        this.$message.success("二维码上传成功");
        this.fetchCurrentQrcode();
      } catch (err) {
        this.$message.error(err.response?.data?.message || "上传失败");
      }
    },
    resetForm() {
      this.form.image = null;
      this.form.image_url = "";
    }
  },
  mounted() {
    this.fetchCurrentQrcode();
  }
};
</script>
  
  <style scoped>
.qrcode-page {
  padding: 30px;
  background: #f5f7fa;
  min-height: 100vh;
}
.qrcode-card {
  max-width: 600px;
  margin: auto;
}
.header h2 {
  margin: 0 0 10px;
  color: #333;
}
.desc {
  color: #666;
  font-size: 13px;
  margin-bottom: 20px;
}
.preview {
  margin-top: 30px;
  text-align: center;
}
.preview-img {
  max-width: 200px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-top: 10px;
}
</style>
  